module.exports = __webpack_public_path__ + "static/media/img5.67577394.jpg";